import 'babel-polyfill';
import './ie8.js';
/**
 * Import the application module.
 */

import app from './app.module.js';
import pageFooter from './login/footer/flexi.pageFooter.js';
import pageHeader from './login/header/flexi.pageHeader.js';
import account  from './login/account/account.wai.js';
import forgotten from './login/forgotten/wai.forgotten.js';
import Fingerprint2 from 'fingerprintjs2';

angular.module(app)
  .directive('pageFooter', pageFooter)
  .directive('pageHeader', pageHeader)
  .directive('forgotten', forgotten)
  .directive('account', account)
  .value('whitelabel', 'flexi')
  .value('deviceprintFnBmo', Fingerprint2)
  .value('deviceprintFn', Fingerprint2);
/**
 * Import all application styles here.
 */
import './app.flexi.less';


// WEBPACK FOOTER //
// ./src/app.flexi.js